import { provideState } from '@ngrx/store';
import * as CourseActions from './course.actions';
import * as fromApp from './course.reducer';
import * as CourseSelectors from './course.selectors';
import { featureKey } from './course.selectors';

export { CourseActions, CourseSelectors };

export const courseProviders = [provideState(featureKey, fromApp.reducer)];
